// --- SVG Component for Acuity Scheduling ---
export const AcuityScheduling = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`lucide lucide-acuity-scheduling ${className}`}
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="8" r="1.5" fill={color} />
      <circle cx="12" cy="16" r="1.5" fill={color} />
    </svg>
  );
};